import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import {
  DashboardComponent,
  LoginComponent,
  CompanyComponent,
  MarketComponent,
  PageNotFoundComponent,
  PageErrorComponent,
  CourseLockedComponent,
  ConnectComponent,
  LogoutComponent,
  DocumentsComponent,
  TeamComponent,
} from "@/core/pages";

import { AuthGuard } from "@/shared-module/helpers";

const routes: Routes = [
  { path: "login", component: LoginComponent, data: { title: "Login" } },
  { path: "logout", component: LogoutComponent, data: { title: "Logout" } },
  { path: "error", component: PageErrorComponent, data: { title: "Error" } },
  { path: "courselocked", component: CourseLockedComponent, data: { title: "Course locked" } },
  { path: "connect", component: ConnectComponent, data: { title: "Connect" } },

  {
    path: "cvclight/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — CVC Light" },
  },
  {
    path: "cvclight/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — CVC Light" },
  },
  {
    path: "cvclight/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Light" },
  },
  {
    path: "cvclight/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Light" },
  },
  {
    path: "cvclight/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Light" },
  },
  {
    path: "cvclight/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Light" },
  },
  {
    path: "cvclight/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Light" },
  },
  {
    path: "cvclight/market",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Light" },
  },
  {
    path: "cvclight/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — CVC Light" },
  },
  { path: "cvclight/team", component: TeamComponent, canActivate: [AuthGuard], data: { title: "Team — CVC Light" } },

  {
    path: "cvcoriginal/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/market",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — CVC Multiplayer" },
  },
  {
    path: "cvcoriginal/team",
    component: TeamComponent,
    canActivate: [AuthGuard],
    data: { title: "Team — CVC Multiplayer" },
  },

  {
    path: "cvcevo/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — CVC Evo" },
  },
  {
    path: "cvcevo/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — CVC Evo" },
  },
  {
    path: "cvcevo/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Evo" },
  },
  {
    path: "cvcevo/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Evo" },
  },
  {
    path: "cvcevo/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — CVC Evo" },
  },
  {
    path: "cvcevo/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Evo" },
  },
  {
    path: "cvcevo/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Evo" },
  },
  {
    path: "cvcevo/market",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — CVC Evo" },
  },
  {
    path: "cvcevo/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — CVC Evo" },
  },
  { path: "cvcevo/team", component: TeamComponent, canActivate: [AuthGuard], data: { title: "Team — CVC Evo" } },

  {
    path: "fof/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — Finance" },
  },
  {
    path: "fof/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — Finance" },
  },
  {
    path: "fof/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — Finance" },
  },
  {
    path: "fof/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — Finance" },
  },
  {
    path: "fof/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — Finance" },
  },
  {
    path: "fof/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — Finance" },
  },
  {
    path: "fof/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — Finance" },
  },
  { path: "fof/market", component: MarketComponent, canActivate: [AuthGuard], data: { title: "Market — Finance" } },
  {
    path: "fof/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — Finance" },
  },
  { path: "fof/team", component: TeamComponent, canActivate: [AuthGuard], data: { title: "Team — Finance" } },

  {
    path: "tca/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — TCA" },
  },
  {
    path: "tca/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — TCA" },
  },
  {
    path: "tca/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — TCA" },
  },
  {
    path: "tca/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — TCA" },
  },
  {
    path: "tca/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — TCA" },
  },
  {
    path: "tca/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — TCA" },
  },
  {
    path: "tca/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — TCA" },
  },
  { path: "tca/market", component: MarketComponent, canActivate: [AuthGuard], data: { title: "Market — TCA" } },
  {
    path: "tca/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — TCA" },
  },
  { path: "tca/team", component: TeamComponent, canActivate: [AuthGuard], data: { title: "Team — TCA" } },
  {
    path: "hcc/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — HCC" },
  },
  {
    path: "hcc/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — HCC" },
  },
  {
    path: "hcc/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — HCC" },
  },
  {
    path: "hcc/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — HCC" },
  },
  {
    path: "hcc/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — HCC" },
  },
  {
    path: "hcc/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — HCC" },
  },
  {
    path: "hcc/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — HCC" },
  },
  { path: "hcc/market", component: MarketComponent, canActivate: [AuthGuard], data: { title: "Market — HCC" } },
  {
    path: "hcc/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — HCC" },
  },
  { path: "hcc/team", component: TeamComponent, canActivate: [AuthGuard], data: { title: "Team — HCC" } },

  {
    path: "sustainability/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — Sustainability" },
  },
  {
    path: "sustainability/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: "Dashboard — Sustainability" },
  },
  {
    path: "sustainability/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — Sustainability" },
  },
  {
    path: "sustainability/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — Sustainability" },
  },
  {
    path: "sustainability/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
    data: { title: "Company — Sustainability" },
  },
  {
    path: "sustainability/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — Sustainability" },
  },
  {
    path: "sustainability/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { title: "Market — Sustainability" },
  },
  { path: "sustainability/market", component: MarketComponent, canActivate: [AuthGuard], data: { title: "Market — Sustainability" } },
  {
    path: "sustainability/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: { title: "Documents — Sustainability" },
  },
  { path: "sustainability/team", component: TeamComponent, canActivate: [AuthGuard], data: { title: "Team — Sustainability" } },

  {
    path: "cvcoriginal",
    loadChildren: () =>
      import("./cvc-original-module/cvc-original-module.module").then(
        (m) => m.CvcOriginalModuleModule,
      ),
  },
  {
    path: "cvcevo",
    loadChildren: () =>
      import("./cvcevo-module/cvcevo-module.module").then(
        (m) => m.CvcEvoModuleModule,
      ),
  },
  {
    path: "cvclight",
    loadChildren: () =>
      import("./cvc-light-module/cvc-light-module.module").then(
        (m) => m.CvcLightModuleModule,
      ),
  },
  {
    path: "fof",
    loadChildren: () =>
      import("./fof-module/fof-module.module").then((m) => m.FofModuleModule),
  },
  {
    path: "tca",
    loadChildren: () =>
      import("./tca-module/tca-module.module").then((m) => m.TcaModuleModule),
  },
  {
    path: "hcc",
    loadChildren: () =>
      import("./hcc-module/hcc-module.module").then((m) => m.HccModuleModule),
  },
  {
    path: "sustainability",
    loadChildren: () =>
      import("./sustainability-module/sustainability-module.module").then((m) => m.SustainabilityModuleModule),
  },
  // otherwise redirect to home
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  { path: "**", component: PageNotFoundComponent, data: { title: "Page not found" } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
